class SaturationData {
  saturation: number;
  currentHus: number;
  maxCapacity: number;

  constructor({
    saturation,
    currentHus,
    maxCapacity
  }: {
    saturation: number;
    currentHus: number;
    maxCapacity: number;
  }) {
    this.saturation = saturation;
    this.currentHus = currentHus;
    this.maxCapacity = maxCapacity;
  }

  static generateFromDTO(res: any = {}) {
    // Si viene del DTO (camelCase)
    const saturationFromDto = res?.saturation;
    const currentHusFromDto = res?.currentHus;
    const maxCapacityFromDto = res?.maxCapacity;

    // Si viene crudo del API (snake_case + envelope)
    const data = res?.data ?? {};
    const saturationFromApi = data?.saturation_percentage;
    const currentHusFromApi = data?.current_hus;
    const maxCapacityFromApi = data?.max_capacity;

    return new SaturationData({
      saturation: saturationFromDto ?? saturationFromApi ?? 0,
      currentHus: currentHusFromDto ?? currentHusFromApi ?? 0,
      maxCapacity: maxCapacityFromDto ?? maxCapacityFromApi ?? 0
    });
  }

  static generateEmpty() {
    return new SaturationData({
      saturation: 0,
      currentHus: 0,
      maxCapacity: 0
    });
  }
}

export default SaturationData;
